/**
 * @param year - badge year
 * Returns image version depending on year
 */
export const getBadgeImageVersion = (year: number) => {
  if (year >= 2025) return '@v1';
  if (year === 2024) return '@v5';
  return '@v3';
};
